import 'owl.carousel';

var item_index = 0;
var item_count = 0;
var target_title = 0;
var target_index = 0;
var spacer = false;
const title = document.querySelector('.c-hero_slider__title');

const secondary_title = document.querySelector('.c-hero_slider__secondary');

function init() {

  const sliders = document.querySelectorAll('.owl-carousel');

  if (!sliders) {
    return;
  }

  OwlCarousel1();

}

function OwlCarousel1() {

  $('.featured-carousel').owlCarousel({

    margin: 20,
    autoplay: false,
    items: 1,
    nav: true,
    navText : [$('.c-featured__left_arrow'),$('.c-featured__right_arrow')],
    dots: true

  });

  var $lightbox = $('.owl-carousel.c-slider').owlCarousel({

    center: true,
    items:1,
    loop:true,
    margin: 10,
    nav: true,
    responsive:{
      900:{

      }
    }

  });

  setTimeout(function(){

    $(".c-modal__window").each(function() {
      if(this.querySelector(".owl-next")){
        this.querySelector(".owl-next").style.display = 'none';
        this.querySelector(".owl-prev").style.display = 'none';
        this.querySelector(".owl-nav").appendChild(this.querySelector(".c-slider__previous"));
        this.querySelector(".owl-nav").appendChild(this.querySelector(".c-slider__next"));
      }
    });

  }, 1000);

  // Go to the next item
  $('.c-slider__next').click(function() {
      $lightbox.trigger('next.owl.carousel');
  })
  // Go to the previous item
  $('.c-slider__previous').click(function() {
      // With optional speed parameter
      // Parameters has to be in square bracket '[]'
      $lightbox.trigger('prev.owl.carousel');
  })

  window.$lightbox = $lightbox;

  $lightbox.trigger('refresh.owl.carousel');

  $(window).resize(function() {
    $lightbox.trigger('refresh.owl.carousel');
  });

}


export default init;
